import { render, staticRenderFns } from "./YfPanelHeadingMultiselect.vue?vue&type=template&id=3c8c80d2&"
import script from "./YfPanelHeadingMultiselect.vue?vue&type=script&lang=js&"
export * from "./YfPanelHeadingMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./YfPanelHeadingMultiselect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports